import { motion } from 'framer-motion';
import './about.css';
import image from '../images/about.png';
import Header from '../components/header';
import ProfileCard from '../components/ProfileCard';
import ApproachSection from '../components/ApproachSection';
import Timeline from '../components/Timeline';
import Footer from '../components/footer';

function About() {
  return (
    <div className="about-page">
      <Header />

      <main>
        {/* ─── Profile Section ─── */}
        <section className="profile-section">
          <motion.div
            className="profile-card-wrapper"
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <ProfileCard
              name="doazhu"
              title="Backend Developer"
              handle="doazhu"
              status="Открыт для проектов"
              contactText="Написать"
              avatarUrl={image}
              iconUrl="/iconpattern.svg"
              showUserInfo={false}
              avatarScale={1.3}
              enableTilt={true}
              enableMobileTilt={false}
              onContactClick={() => window.open('https://t.me/Doazhu', '_blank')}
              behindGlowColor="rgba(82, 39, 255, 0.55)"
              innerGradient="linear-gradient(145deg, #160820 0%, #0a1020 100%)"
              behindGlowEnabled={true}
            />
          </motion.div>

          <motion.div
            className="bio-block"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
          >
            <span className="section-eyebrow-about">Обо мне</span>
            <h1 className="bio-title">
              <span style={{ color: 'var(--toxic-yellow)' }}>Я Александр</span>
            </h1>

            <p className="bio-text">
              Более пяти лет занимаюсь backend-разработкой. Специализируюсь на проектировании
              серверной архитектуры, REST API и работе с базами данных. Основной стек —
              Python, FastAPI, Django, PostgreSQL.
            </p>
            <p className="bio-text">
              За это время реализовал 89+ проектов — от небольших сервисов до высоконагруженных
              систем с микросервисной архитектурой, очередями сообщений и кэшированием.
            </p>
            <p className="bio-text">
              Опыт работы с Docker, Nginx, Redis, Kafka. Пишу чистый, поддерживаемый код
              и проектирую системы, готовые к масштабированию.
            </p>

            <div className="bio-tags">
              {['Python', 'FastAPI', 'Django', 'PostgreSQL', 'Docker', 'Redis', 'Kafka', 'Nginx'].map((tag) => (
                <span key={tag} className="bio-tag">{tag}</span>
              ))}
            </div>
          </motion.div>
        </section>

        {/* ─── Timeline ─── */}
        <motion.div
          className="timeline-container"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Timeline />
        </motion.div>

        {/* ─── Bento Section ─── */}
        <section className="bento-section">
          <div className="section-header-centered">
            <span className="section-eyebrow-about">Как я работаю</span>
            <h2 className="section-heading-new accent-font">Мой подход</h2>
          </div>
          <ApproachSection />
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
